module.exports = __webpack_public_path__ + "media/images/logos/app-logo-navy-2000px-ee0d454f972e841bfe8168a451b03e5d.png";